import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import CulinaryJourney from '../../components/CulinaryJourney/CulinaryJourney';
import './AboutPage.css';

const AboutPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="about-page">
            <motion.div
                className="page-header"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <h1>{t('about.title')}</h1>
                <p>{t('about.subtitle')}</p>
            </motion.div>

            <div className="about-container">
                <CulinaryJourney />

                <motion.section
                    className="about-intro"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <div className="intro-content">
                        {t('about.description').split('\n\n').map((paragraph: string, index: number) => (
                            <p key={index} className="about-description-paragraph">
                                {paragraph}
                            </p>
                        ))}
                    </div>
                </motion.section>

                <section className="features-showcase">
                    <motion.div
                        className="feature-item"
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                    >
                        <div className="feature-image">
                            <img src="https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800" alt="Quality" loading="lazy" decoding="async" />
                        </div>
                        <div className="feature-content">
                            <h2>{t('about.features.quality.title')}</h2>
                            <p>{t('about.features.quality.description')}</p>
                        </div>
                    </motion.div>

                    <motion.div
                        className="feature-item reverse"
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                    >
                        <div className="feature-image">
                            <img src="https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=800" alt="Safety" loading="lazy" decoding="async" />
                        </div>
                        <div className="feature-content">
                            <h2>{t('about.features.safety.title')}</h2>
                            <p>{t('about.features.safety.description')}</p>
                        </div>
                    </motion.div>

                    <motion.div
                        className="feature-item"
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                    >
                        <div className="feature-image">
                            <img src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800" alt="Innovation" loading="lazy" decoding="async" />
                        </div>
                        <div className="feature-content">
                            <h2>{t('about.features.innovation.title')}</h2>
                            <p>{t('about.features.innovation.description')}</p>
                        </div>
                    </motion.div>

                    <motion.div
                        className="feature-item reverse"
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                    >
                        <div className="feature-image">
                            <img src="https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800" alt="Global" loading="lazy" decoding="async" />
                        </div>
                        <div className="feature-content">
                            <h2>{t('about.features.global.title')}</h2>
                            <p>{t('about.features.global.description')}</p>
                        </div>
                    </motion.div>
                </section>

                <motion.section
                    className="stats-section"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <div className="stats-grid">
                        <div className="stat-card">
                            <div className="stat-number">15+</div>
                            <div className="stat-label">Years of Experience</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">50+</div>
                            <div className="stat-label">Airlines Served</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">1M+</div>
                            <div className="stat-label">Meals Served Monthly</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">30+</div>
                            <div className="stat-label">Countries</div>
                        </div>
                    </div>
                </motion.section>
            </div>
        </div>
    );
};

export default AboutPage;
